// Direction labels/icons shared across training UIs.
export const DIR_LABEL = {
  up: '↑',
  down: '↓',
  left: '←',
  right: '→',
};

export const DIR_ICON = {
  up: '/up.png',
  down: '/down.png',
  left: '/left.png',
  right: '/right.png',
};
